import styled from 'styled-components';

export const ScrollableContainer = styled.div`
  padding-top: 20px;
  max-height: 560px;
  overflow-y: scroll;
  scrollbar-width: none;
`;

export const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProductCard = styled.div`
  width: 460px;

  border-radius: 4px;
  border: 1px solid #ededed;

  padding: 12px 16px;

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProductCardHeader = styled.div`
  border-bottom: 1px solid #ededed;
  padding-bottom: 12px;
`;

export const ProductCardBody = styled.div`
  display: flex;
  justify-content: space-between;
`;
